import React from 'react';
import styled from 'styled-components';
import { createTheme } from '@material-ui/core/styles';
import { AppBar, Box } from '@material-ui/core';

export const TabsAppBar = styled(AppBar)`
  color: black;
  background-color: white;
`
export const tabsIndicatorTheme = createTheme({
  overrides: {
    // Style sheet name ⚛️
    MuiTabs: {
      // Name of the rule
      indicator: {
        // Some CSS
        backgroundColor: '#bdbdbd',
      },
    },
  },
})

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

export const a11yProps = (index: any) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export default TabPanel;
